(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("Coveo"), require("CoveoForSitecoreUserContext"));
	else if(typeof define === 'function' && define.amd)
		define(["Coveo", "CoveoForSitecoreUserContext"], factory);
	else if(typeof exports === 'object')
		exports["CoveoForSitecore"] = factory(require("Coveo"), require("CoveoForSitecoreUserContext"));
	else
		root["CoveoForSitecore"] = factory(root["Coveo"], root["CoveoForSitecoreUserContext"]);
})(this, function(__WEBPACK_EXTERNAL_MODULE_0__, __WEBPACK_EXTERNAL_MODULE_73__) {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// install a JSONP callback for chunk loading
/******/ 	var parentJsonpFunction = window["webpackJsonpCoveoForSitecore"];
/******/ 	window["webpackJsonpCoveoForSitecore"] = function webpackJsonpCallback(chunkIds, moreModules, executeModules) {
/******/ 		// add "moreModules" to the modules object,
/******/ 		// then flag all "chunkIds" as loaded and fire callback
/******/ 		var moduleId, chunkId, i = 0, resolves = [], result;
/******/ 		for(;i < chunkIds.length; i++) {
/******/ 			chunkId = chunkIds[i];
/******/ 			if(installedChunks[chunkId]) {
/******/ 				resolves.push(installedChunks[chunkId][0]);
/******/ 			}
/******/ 			installedChunks[chunkId] = 0;
/******/ 		}
/******/ 		for(moduleId in moreModules) {
/******/ 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
/******/ 				modules[moduleId] = moreModules[moduleId];
/******/ 			}
/******/ 		}
/******/ 		if(parentJsonpFunction) parentJsonpFunction(chunkIds, moreModules, executeModules);
/******/ 		while(resolves.length) {
/******/ 			resolves.shift()();
/******/ 		}
/******/
/******/ 	};
/******/
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// objects to store loaded and loading chunks
/******/ 	var installedChunks = {
/******/ 		14: 0
/******/ 	};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/ 	// This file contains only the entry chunk.
/******/ 	// The chunk loading function for additional chunks
/******/ 	__webpack_require__.e = function requireEnsure(chunkId) {
/******/ 		var installedChunkData = installedChunks[chunkId];
/******/ 		if(installedChunkData === 0) {
/******/ 			return new Promise(function(resolve) { resolve(); });
/******/ 		}
/******/
/******/ 		// a Promise means "currently loading".
/******/ 		if(installedChunkData) {
/******/ 			return installedChunkData[2];
/******/ 		}
/******/
/******/ 		// setup Promise in chunk cache
/******/ 		var promise = new Promise(function(resolve, reject) {
/******/ 			installedChunkData = installedChunks[chunkId] = [resolve, reject];
/******/ 		});
/******/ 		installedChunkData[2] = promise;
/******/
/******/ 		// start chunk loading
/******/ 		var head = document.getElementsByTagName('head')[0];
/******/ 		var script = document.createElement('script');
/******/ 		script.type = 'text/javascript';
/******/ 		script.charset = 'utf-8';
/******/ 		script.async = true;
/******/ 		script.timeout = 120000;
/******/
/******/ 		if (__webpack_require__.nc) {
/******/ 			script.setAttribute("nonce", __webpack_require__.nc);
/******/ 		}
/******/ 		script.src = __webpack_require__.p + "" + ({"0":"CoveoForSitecoreRankingExpression","1":"CoveoForSitecoreFilterExpression","2":"DistanceResources","3":"GoogleApiPositionProvider","4":"CoveoForSitecoreExternalContent","5":"SendAnalyticsToSitecore","6":"StaticPositionProvider","7":"NavigatorPositionProvider","8":"CoveoForSitecoreLocalExpression","9":"CoveoForSitecoreExpressions","10":"CoveoForSitecoreBindWithUserContext","11":"ValidateAnalyticsIncluded","12":"CoveoForSitecoreAnalytics"}[chunkId]||chunkId) + ".min.js";
/******/ 		var timeout = setTimeout(onScriptComplete, 120000);
/******/ 		script.onerror = script.onload = onScriptComplete;
/******/ 		function onScriptComplete() {
/******/ 			// avoid mem leaks in IE.
/******/ 			script.onerror = script.onload = null;
/******/ 			clearTimeout(timeout);
/******/ 			var chunk = installedChunks[chunkId];
/******/ 			if(chunk !== 0) {
/******/ 				if(chunk) {
/******/ 					chunk[1](new Error('Loading chunk ' + chunkId + ' failed.'));
/******/ 				}
/******/ 				installedChunks[chunkId] = undefined;
/******/ 			}
/******/ 		};
/******/ 		head.appendChild(script);
/******/
/******/ 		return promise;
/******/ 	};
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// identity function for calling harmony imports with the correct context
/******/ 	__webpack_require__.i = function(value) { return value; };
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "js/";
/******/
/******/ 	// on error function for async loading
/******/ 	__webpack_require__.oe = function(err) { console.error(err); throw err; };
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 75);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_0__;

/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var SitecoreContextEvents = (function () {
    function SitecoreContextEvents() {
    }
    return SitecoreContextEvents;
}());
SitecoreContextEvents.onSitecoreContextInitialization = "onSitecoreContextInitialization";
exports.SitecoreContextEvents = SitecoreContextEvents;


/***/ }),
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var PrebindResolver_1 = __webpack_require__(36);
var Prebinding = (function () {
    function Prebinding() {
    }
    Prebinding.registerPrebindHelper = function (helperName, handler) {
        this.processor.registerPrebindHelper(helperName, handler);
    };
    Prebinding.getHelper = function (helperName) {
        return this.processor.getHelper(helperName);
    };
    Prebinding.applyPrebindingOnElement = function (rootElement) {
        if (this.processor.hasNotAppliedPrebind(rootElement)) {
            this.processor.applyToElement(rootElement);
        }
    };
    Prebinding.applyPrebindingOnChildren = function (rootElement) {
        var _this = this;
        this.nodeListToArray(rootElement.querySelectorAll("*"))
            .map(function (element) { return element; })
            .filter(function (element) { return _this.processor.hasNotAppliedPrebind(element); })
            .forEach(function (element) { return _this.processor.applyToElement(element); });
    };
    Prebinding.nodeListToArray = function (elements) {
        var array = [];
        for (var i = 0, length = elements.length; i < length; i++) {
            array.push(elements[i]);
        }
        return array;
    };
    return Prebinding;
}());
Prebinding.processor = new PrebindResolver_1.PrebindResolver();
exports.Prebinding = Prebinding;


/***/ }),
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var ContextInitializer_1 = __webpack_require__(29);
var CoveoForSitecoreContext_1 = __webpack_require__(5);
var coveo_search_ui_1 = __webpack_require__(0);
var Context = (function () {
    function Context() {
    }
    Context.configureContext = function (contextElement) {
        if (typeof (contextElement) === "undefined" || contextElement === null) {
            throw Error("You must execute `configureContext` with an HTML element.");
        }
        var options = coveo_search_ui_1.ComponentOptions.initComponentOptions(contextElement, CoveoForSitecoreContext_1.CoveoForSitecoreContext);
        this.initializeWithContextOptions(contextElement, options);
    };
    Context.initializeWithContextOptions = function (contextElement, contextOptions) {
        var contextInitializer = new ContextInitializer_1.ContextInitializer();
        var fieldsHandler = contextInitializer.createFieldsHandler({
            externalFields: contextOptions.scExternalFields,
            prefix: contextOptions.scFieldPrefix,
            suffix: contextOptions.scFieldSuffix
        });
        var labels = contextInitializer.createLabelsHandler({
            labels: contextOptions.scLabels
        });
        var sourceName = contextOptions.scIndexSourceName;
        contextInitializer.initializePrebinding({
            fieldsHandler: fieldsHandler,
            context: contextOptions
        });
        contextInitializer.initializeUnderscoreFieldsHelpers(fieldsHandler);
        contextInitializer.initializeUnderscoreLabelsHelpers(labels);
        contextInitializer.initializeUnderscoreContextHelpers(sourceName);
        contextInitializer.initializeContextElement(contextElement);
        this.fields = fieldsHandler;
        this.labels = labels;
        this.element = contextElement;
    };
    return Context;
}());
exports.Context = Context;


/***/ }),
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var ExternalComponentInitializer_1 = __webpack_require__(30);
var SearchboxInitializer_1 = __webpack_require__(32);
var SearchInterfaceInitializer_1 = __webpack_require__(31);
var ElementWithContextInitializer_1 = __webpack_require__(8);
exports.searchInterfaceInitializer = new SearchInterfaceInitializer_1.SearchInterfaceInitializer();
exports.searchboxInitializer = new SearchboxInitializer_1.SearchboxInitializer();
exports.externalComponentInitializer = new ExternalComponentInitializer_1.ExternalComponentInitializer();
function initSearchInterface(searchInterfaceElement) {
    return exports.searchInterfaceInitializer.initSearchInterface(searchInterfaceElement);
}
exports.initSearchInterface = initSearchInterface;
function initializeSearchInterfaceForExperienceEditor(searchInterfaceElement) {
    exports.searchInterfaceInitializer.initializeExperienceEditorHooksForSearchInterface(searchInterfaceElement);
    return initSearchInterface(searchInterfaceElement);
}
exports.initializeSearchInterfaceForExperienceEditor = initializeSearchInterfaceForExperienceEditor;
function initSearchboxIfStandalone(searchBoxElement, searchPageUri, options) {
    return exports.searchboxInitializer.initSearchboxIfStandalone(searchBoxElement, searchPageUri, options);
}
exports.initSearchboxIfStandalone = initSearchboxIfStandalone;
function initContextOnElement(element) {
    ElementWithContextInitializer_1.ElementWithContextInitializer.initializeContextWithinElement(element);
}
exports.initContextOnElement = initContextOnElement;
function initExternalComponentsSection(element) {
    exports.externalComponentInitializer.initializeExternalComponentSection(element);
}
exports.initExternalComponentsSection = initExternalComponentsSection;
function initExternalComponentsSectionForExperienceEditor(element) {
    exports.externalComponentInitializer.initializeExperienceEditorHooksForExternalComponentsSection(element);
    initExternalComponentsSection(element);
}
exports.initExternalComponentsSectionForExperienceEditor = initExternalComponentsSectionForExperienceEditor;


/***/ }),
/* 5 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var coveo_search_ui_1 = __webpack_require__(0);
var ContextEvents_1 = __webpack_require__(1);
var CoveoForSitecoreContext = (function (_super) {
    __extends(CoveoForSitecoreContext, _super);
    function CoveoForSitecoreContext(element, options, bindings) {
        var _this = _super.call(this, element, CoveoForSitecoreContext.ID, bindings) || this;
        _this.element = element;
        _this.options = options;
        _this.bindings = bindings;
        _this.options = coveo_search_ui_1.ComponentOptions.initComponentOptions(element, CoveoForSitecoreContext, options);
        _this.bind.onRootElement(coveo_search_ui_1.InitializationEvents.afterComponentsInitialization, _this.afterComponentsInitialization);
        _this.bind.onRootElement(coveo_search_ui_1.QueryEvents.doneBuildingQuery, _this.doneBuildingQuery);
        return _this;
    }
    CoveoForSitecoreContext.prototype.doneBuildingQuery = function (args) {
        if (this.hasDefaultPipelineNameSet() && this.queryBuilderUsesDefaultPipeline(args.queryBuilder)) {
            args.queryBuilder.pipeline = this.options.scDefaultPipelineName;
        }
    };
    CoveoForSitecoreContext.prototype.hasDefaultPipelineNameSet = function () {
        return this.options.scDefaultPipelineName !== "";
    };
    CoveoForSitecoreContext.prototype.queryBuilderUsesDefaultPipeline = function (queryBuilder) {
        return typeof (queryBuilder.pipeline) === "undefined";
    };
    CoveoForSitecoreContext.prototype.afterComponentsInitialization = function () {
        var contextArgs = {
            sitecoreItemUri: this.options.scItemUri,
            sitecorePageName: this.options.scPageName,
            analyticsEnabled: this.options.scAnalyticsEnabled,
            indexSourceName: this.options.scIndexSourceName,
            currentLanguage: this.options.scCurrentLanguage,
            languageFieldName: this.options.scLanguageFieldName,
            latestVersionFieldName: this.options.scLatestVersionFieldName
        };
        this.bind.trigger(this.element, ContextEvents_1.SitecoreContextEvents.onSitecoreContextInitialization, contextArgs);
    };
    return CoveoForSitecoreContext;
}(coveo_search_ui_1.Component));
CoveoForSitecoreContext.ID = "ForSitecoreContext";
CoveoForSitecoreContext.options = {
    scItemUri: coveo_search_ui_1.ComponentOptions.buildStringOption(),
    scLanguageFieldName: coveo_search_ui_1.ComponentOptions.buildStringOption(),
    scLatestVersionFieldName: coveo_search_ui_1.ComponentOptions.buildStringOption(),
    scCurrentLanguage: coveo_search_ui_1.ComponentOptions.buildStringOption(),
    scRestEndpointUri: coveo_search_ui_1.ComponentOptions.buildStringOption(),
    scLabels: coveo_search_ui_1.ComponentOptions.buildJsonOption(),
    scPageName: coveo_search_ui_1.ComponentOptions.buildStringOption(),
    scDefaultPipelineName: coveo_search_ui_1.ComponentOptions.buildStringOption(),
    scAnalyticsEnabled: coveo_search_ui_1.ComponentOptions.buildBooleanOption(),
    scIsUserAnonymous: coveo_search_ui_1.ComponentOptions.buildBooleanOption(),
    scFieldPrefix: coveo_search_ui_1.ComponentOptions.buildStringOption(),
    scFieldSuffix: coveo_search_ui_1.ComponentOptions.buildStringOption(),
    scExternalFields: coveo_search_ui_1.ComponentOptions.buildJsonOption(),
    scIndexSourceName: coveo_search_ui_1.ComponentOptions.buildStringOption()
};
exports.CoveoForSitecoreContext = CoveoForSitecoreContext;
coveo_search_ui_1.Initialization.registerAutoCreateComponent(CoveoForSitecoreContext);


/***/ }),
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var SitecoreExpressionEvents = (function () {
    function SitecoreExpressionEvents() {
    }
    return SitecoreExpressionEvents;
}());
SitecoreExpressionEvents.onBuildingSitecoreExternalContent = "onBuildingSitecoreExternalContent";
SitecoreExpressionEvents.onBuildingLocalSitecoreInstanceExpression = "onBuildingLocalSitecoreInstanceExpression";
exports.SitecoreExpressionEvents = SitecoreExpressionEvents;


/***/ }),
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
function nodeListToArray(elements) {
    var array = [];
    for (var i = 0, length = elements.length; i < length; i++) {
        var element = elements.item(i);
        if (element instanceof HTMLElement) {
            array.push(element);
        }
    }
    return array;
}
exports.nodeListToArray = nodeListToArray;


/***/ }),
/* 8 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var Prebinding_1 = __webpack_require__(2);
var Context_1 = __webpack_require__(3);
var ElementWithContextInitializer = (function () {
    function ElementWithContextInitializer() {
    }
    ElementWithContextInitializer.initializeContextWithinElement = function (element) {
        if (!!Context_1.Context.element) {
            element.appendChild(Context_1.Context.element.cloneNode(true));
        }
        Prebinding_1.Prebinding.applyPrebindingOnElement(element);
        Prebinding_1.Prebinding.applyPrebindingOnChildren(element);
    };
    return ElementWithContextInitializer;
}());
exports.ElementWithContextInitializer = ElementWithContextInitializer;


/***/ }),
/* 9 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var HTMLUtils_1 = __webpack_require__(7);
var SitecoreExperienceEditor = (function () {
    function SitecoreExperienceEditor() {
        this.isOverriden = false;
        this.onAfterFrameLoadedCallbacks = [];
    }
    SitecoreExperienceEditor.prototype.registerOnLoadRenderingFromUrl = function (onAfterFrameLoadedCallback) {
        this.overrideSitecoreLoadRenderingFromUrl();
        this.onAfterFrameLoadedCallbacks.push(onAfterFrameLoadedCallback);
    };
    SitecoreExperienceEditor.prototype.isInBackgroundRendering = function () {
        return window.location.search.indexOf(SitecoreExperienceEditor.isInBackgroundRenderingParameterName) !== -1;
    };
    SitecoreExperienceEditor.prototype.getComponentFromLoadRenderingFromUrlCallbackData = function (callbackData) {
        if (!callbackData.renderingElement) {
            console.error("Could not find the rendering element from Sitecore callback data.", callbackData);
        }
        var chromeRendering = document.getElementById(callbackData.renderingElement.opening[0].id);
        return chromeRendering.nextElementSibling;
    };
    SitecoreExperienceEditor.prototype.overrideSitecoreLoadRenderingFromUrl = function () {
        var _this = this;
        if (!this.isOverriden && typeof (Sitecore) !== "undefined") {
            var originalLoad_1 = Sitecore.PageModes.ChromeTypes.Placeholder.prototype._loadRenderingFromUrl;
            var onAfterFrameLoadedCallback_1 = function (callbackData) {
                _this.onAfterFrameLoadedCallbacks.forEach(function (callback) { return callback(callbackData); });
            };
            Sitecore.PageModes.ChromeTypes.Placeholder.prototype._loadRenderingFromUrl = function (url, frameLoadedCallback) {
                originalLoad_1.call(this, url + "&" + SitecoreExperienceEditor.isInBackgroundRenderingParameterName + "=1", function (callbackData) {
                    frameLoadedCallback.call(this, callbackData);
                    onAfterFrameLoadedCallback_1(callbackData);
                });
            };
            this.isOverriden = true;
        }
    };
    SitecoreExperienceEditor.prototype.registerShowDebugInformationCallback = function () {
        if (!window["scCoveoShowDebugInformation"]) {
            window["scCoveoShowDebugInformation"] = function (debugModeEnabled) {
                var debugInfoElements = HTMLUtils_1.nodeListToArray(document.getElementsByClassName("coveo-debug-information"));
                if (debugModeEnabled) {
                    debugInfoElements.forEach(function (element) { return element.classList.remove("coveo-debug-hidden"); });
                }
                else {
                    debugInfoElements.forEach(function (element) { return element.classList.add("coveo-debug-hidden"); });
                }
                // Chromes are not updated correctly until an event refreshes them. This forces the update.
                Sitecore.PageModes.ChromeManager.resetChromes();
            };
        }
    };
    return SitecoreExperienceEditor;
}());
SitecoreExperienceEditor.isInBackgroundRenderingParameterName = "isInBackgroundRendering";
exports.SitecoreExperienceEditor = SitecoreExperienceEditor;
var staticInstance = new SitecoreExperienceEditor();
function getExperienceEditorInstance() {
    return staticInstance;
}
exports.getExperienceEditorInstance = getExperienceEditorInstance;


/***/ }),
/* 10 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var Prebinding_1 = __webpack_require__(2);
var coveo_search_ui_1 = __webpack_require__(0);
var externalComponentsOption = "externalComponents";
var SearchInterfaceComponentInitializer = (function () {
    function SearchInterfaceComponentInitializer() {
    }
    SearchInterfaceComponentInitializer.prototype.loadComponentsForSearchInterface = function (searchInterface, newComponent) {
        Prebinding_1.Prebinding.applyPrebindingOnElement(newComponent);
        Prebinding_1.Prebinding.applyPrebindingOnChildren(newComponent);
        var result = Coveo.Initialization.automaticallyCreateComponentsInside(newComponent, {
            bindings: searchInterface.getBindings(),
            options: {}
        });
        return result.initResult.then(function () {
            searchInterface.queryController.executeQuery({
                ignoreWarningSearchEvent: true
            });
        });
    };
    SearchInterfaceComponentInitializer.prototype.loadComponentsWithSearchInterfaceInitialization = function (searchInterfaceElement, element) {
        var _this = this;
        coveo_search_ui_1.$$(searchInterfaceElement).on(coveo_search_ui_1.InitializationEvents.beforeInitialization, function () {
            var searchInterfaceComponent = coveo_search_ui_1.get(searchInterfaceElement, coveo_search_ui_1.SearchInterface);
            _this.pushElementInSearchInterfaceExternalComponents(searchInterfaceComponent, element);
        });
    };
    SearchInterfaceComponentInitializer.prototype.pushElementInSearchInterfaceExternalComponents = function (searchInterfaceComponent, element) {
        if (!searchInterfaceComponent.options[externalComponentsOption]) {
            searchInterfaceComponent.options[externalComponentsOption] = [];
        }
        searchInterfaceComponent.options[externalComponentsOption].push(element);
    };
    return SearchInterfaceComponentInitializer;
}());
exports.SearchInterfaceComponentInitializer = SearchInterfaceComponentInitializer;
var initializer = new SearchInterfaceComponentInitializer();
function getInitializerInstance() {
    return initializer;
}
exports.getInitializerInstance = getInitializerInstance;


/***/ }),
/* 11 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var Context_1 = __webpack_require__(3);
exports.Context = Context_1.Context;
var Prebinding_1 = __webpack_require__(2);
exports.Prebinding = Prebinding_1.Prebinding;
var SearchEndpoint_1 = __webpack_require__(28);
exports.SearchEndpoint = SearchEndpoint_1.SearchEndpoint;


/***/ }),
/* 12 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var ContextEvents_1 = __webpack_require__(1);
exports.SitecoreContextEvents = ContextEvents_1.SitecoreContextEvents;
var ExpressionEvents_1 = __webpack_require__(6);
exports.SitecoreExpressionEvents = ExpressionEvents_1.SitecoreExpressionEvents;


/***/ }),
/* 13 */,
/* 14 */,
/* 15 */,
/* 16 */,
/* 17 */,
/* 18 */,
/* 19 */,
/* 20 */,
/* 21 */,
/* 22 */,
/* 23 */,
/* 24 */,
/* 25 */,
/* 26 */,
/* 27 */,
/* 28 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var coveo_search_ui_1 = __webpack_require__(0);
var SearchEndpoint = (function () {
    function SearchEndpoint() {
    }
    SearchEndpoint.configureSitecoreEndpoint = function (options) {
        if (typeof (options) === "undefined") {
            throw Error("You must define endpoint options when calling 'configureSitecoreEndpoint'.");
        }
        coveo_search_ui_1.SearchEndpoint.endpoints["default"] = SearchEndpoint.createNewEndpoint(options);
    };
    SearchEndpoint.createNewEndpoint = function (options) {
        return new coveo_search_ui_1.SearchEndpoint({
            restUri: options.restEndpointUri || "/coveo/rest",
            queryStringArguments: {
                "sitecoreItemUri": options.itemUri,
                "siteName": options.siteName
            }
        });
    };
    return SearchEndpoint;
}());
exports.SearchEndpoint = SearchEndpoint;


/***/ }),
/* 29 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var CoveoFieldsHandler_1 = __webpack_require__(33);
var CoveoLabelsHandler_1 = __webpack_require__(34);
var Prebinding_1 = __webpack_require__(2);
var PrebindHelpers_1 = __webpack_require__(35);
var coveo_search_ui_1 = __webpack_require__(0);
var ContextInitializer = (function () {
    function ContextInitializer() {
    }
    ContextInitializer.prototype.createFieldsHandler = function (options) {
        var externalFields = typeof (options.externalFields) !== "undefined" ? JSON.parse(options.externalFields) : [];
        return new CoveoFieldsHandler_1.CoveoFieldsHandler(externalFields, options.prefix, options.suffix);
    };
    ContextInitializer.prototype.createLabelsHandler = function (options) {
        var labels = typeof (options.labels) !== "undefined" ? JSON.parse(options.labels) : {};
        return new CoveoLabelsHandler_1.CoveoLabelsHandler(labels);
    };
    ContextInitializer.prototype.initializePrebinding = function (args) {
        PrebindHelpers_1.PrebindHelpers.getAllPrebindHelpers().forEach(function (helper) {
            Prebinding_1.Prebinding.registerPrebindHelper(helper.name, helper.getPrebind(args));
        });
    };
    ContextInitializer.prototype.initializeUnderscoreFieldsHelpers = function (fieldsHandler) {
        coveo_search_ui_1.TemplateHelpers.registerTemplateHelper("coveoFieldValue", function (fieldName) {
            return this.raw[fieldsHandler.toCoveo(fieldName)];
        });
        coveo_search_ui_1.TemplateHelpers.registerTemplateHelper("coveoFieldName", function (fieldName) {
            return fieldsHandler.toCoveo(fieldName);
        });
    };
    ContextInitializer.prototype.initializeUnderscoreLabelsHelpers = function (labels) {
        coveo_search_ui_1.TemplateHelpers.registerTemplateHelper("translateLabel", function (labelKey) {
            return labels.translate(labelKey);
        });
    };
    ContextInitializer.prototype.initializeUnderscoreContextHelpers = function (sourceName) {
        coveo_search_ui_1.TemplateHelpers.registerTemplateHelper("currentSourceName", function () {
            return sourceName;
        });
    };
    ContextInitializer.prototype.initializeContextElement = function (contextElement) {
        Prebinding_1.Prebinding.applyPrebindingOnElement(contextElement);
    };
    return ContextInitializer;
}());
exports.ContextInitializer = ContextInitializer;


/***/ }),
/* 30 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var SearchInterfaceComponentInitializer_1 = __webpack_require__(10);
var SitecoreExperienceEditor_1 = __webpack_require__(9);
var coveo_search_ui_1 = __webpack_require__(0);
var ExternalComponentInitializer = (function () {
    function ExternalComponentInitializer(experienceEditor, searchInterfaceComponentInitializer) {
        if (experienceEditor === void 0) { experienceEditor = SitecoreExperienceEditor_1.getExperienceEditorInstance(); }
        if (searchInterfaceComponentInitializer === void 0) { searchInterfaceComponentInitializer = SearchInterfaceComponentInitializer_1.getInitializerInstance(); }
        this.experienceEditor = experienceEditor;
        this.searchInterfaceComponentInitializer = searchInterfaceComponentInitializer;
    }
    ExternalComponentInitializer.prototype.initializeExternalComponentSection = function (externalComponentsSection) {
        var searchInterface = this.findSearchInterfaceForSection(externalComponentsSection);
        if (!!searchInterface) {
            this.searchInterfaceComponentInitializer.loadComponentsWithSearchInterfaceInitialization(searchInterface, externalComponentsSection);
        }
    };
    ExternalComponentInitializer.prototype.initializeExperienceEditorHooksForExternalComponentsSection = function (externalComponentsSection) {
        var _this = this;
        var searchInterface = this.findSearchInterfaceForSection(externalComponentsSection);
        if (!!searchInterface) {
            this.experienceEditor.registerOnLoadRenderingFromUrl(function (callbackData) {
                if (!callbackData.error) {
                    var component = _this.experienceEditor.getComponentFromLoadRenderingFromUrlCallbackData(callbackData);
                    if (externalComponentsSection.contains(component)) {
                        _this.searchInterfaceComponentInitializer.loadComponentsForSearchInterface(coveo_search_ui_1.get(searchInterface, coveo_search_ui_1.SearchInterface), component);
                    }
                }
            });
        }
    };
    ExternalComponentInitializer.prototype.findSearchInterfaceForSection = function (externalComponentsSection) {
        var searchInterfaceId = externalComponentsSection.dataset.searchInterfaceId;
        var searchInterfaceElement = document.getElementById(searchInterfaceId);
        if (!!searchInterfaceElement) {
            return searchInterfaceElement;
        }
        else {
            console.warn("Could not find the search interface element with the following ID: " + searchInterfaceId + ". Validate \"data-search-interface-id\" on the external components section element.", externalComponentsSection);
        }
    };
    return ExternalComponentInitializer;
}());
exports.ExternalComponentInitializer = ExternalComponentInitializer;


/***/ }),
/* 31 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var Initialization_1 = __webpack_require__(4);
var SearchInterfaceComponentInitializer_1 = __webpack_require__(10);
var SitecoreExperienceEditor_1 = __webpack_require__(9);
var coveo_search_ui_1 = __webpack_require__(0);
var SearchInterfaceInitializer = (function () {
    function SearchInterfaceInitializer(experienceEditor, searchInterfaceComponentInitializer) {
        if (experienceEditor === void 0) { experienceEditor = SitecoreExperienceEditor_1.getExperienceEditorInstance(); }
        if (searchInterfaceComponentInitializer === void 0) { searchInterfaceComponentInitializer = SearchInterfaceComponentInitializer_1.getInitializerInstance(); }
        this.experienceEditor = experienceEditor;
        this.searchInterfaceComponentInitializer = searchInterfaceComponentInitializer;
    }
    SearchInterfaceInitializer.prototype.initSearchInterface = function (searchInterface) {
        if (!this.experienceEditor.isInBackgroundRendering()) {
            this.experienceEditor.registerShowDebugInformationCallback();
            Initialization_1.initContextOnElement(searchInterface);
            return coveo_search_ui_1.init(searchInterface);
        }
    };
    SearchInterfaceInitializer.prototype.initializeExperienceEditorHooksForSearchInterface = function (searchInterface) {
        var _this = this;
        this.experienceEditor.registerOnLoadRenderingFromUrl(function (callbackData) {
            if (!callbackData.error) {
                var component = _this.experienceEditor.getComponentFromLoadRenderingFromUrlCallbackData(callbackData);
                // Since multiple search interfaces can register event handlers, this ensures that the component is initializing for the correct search interface.
                if (searchInterface.contains(component)) {
                    var searchInterfaceComponent = Coveo.get(searchInterface, Coveo.SearchInterface);
                    _this.searchInterfaceComponentInitializer.loadComponentsForSearchInterface(searchInterfaceComponent, component);
                }
            }
        });
    };
    return SearchInterfaceInitializer;
}());
exports.SearchInterfaceInitializer = SearchInterfaceInitializer;


/***/ }),
/* 32 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var SearchInterfaceProvider_1 = __webpack_require__(46);
var ElementWithContextInitializer_1 = __webpack_require__(8);
var coveo_search_ui_1 = __webpack_require__(0);
var SearchboxInitializer = (function () {
    function SearchboxInitializer() {
        this.searchInterfacesProvider = new SearchInterfaceProvider_1.SearchInterfacesProvider();
    }
    SearchboxInitializer.prototype.initSearchboxIfStandalone = function (searchboxElement, searchPageUri, options) {
        var _this = this;
        var searchInterfaces = this.searchInterfacesProvider.getSearchInterfacesInPage(["Recommendation", "SearchInterface"]);
        return this.waitForSearchInterfacesInitialization(searchInterfaces).then(function () {
            if (_this.searchboxElementIsNotInitialized(searchboxElement)) {
                if (!!searchPageUri) {
                    ElementWithContextInitializer_1.ElementWithContextInitializer.initializeContextWithinElement(searchboxElement);
                    // coveo-search-ui doesn't like an initSearchbox directly on the searchbox.
                    coveo_search_ui_1.initSearchbox(searchboxElement.parentElement, searchPageUri, options);
                }
                else {
                    console.warn("The search box is not included in any search interface and the \"searchPageUri\" parameters is not specified. Consider using a Global Searchbox instead.", searchboxElement);
                }
            }
        });
    };
    SearchboxInitializer.prototype.searchboxElementIsNotInitialized = function (searchBoxElement) {
        return typeof (coveo_search_ui_1.get(searchBoxElement, Coveo.Searchbox)) === "undefined";
    };
    SearchboxInitializer.prototype.waitForSearchInterfacesInitialization = function (searchInterfaces) {
        return Promise.all(this.getAllSearchInterfacesAfterComponentInitialization(searchInterfaces))
            .then(function () { });
    };
    SearchboxInitializer.prototype.getAllSearchInterfacesAfterComponentInitialization = function (searchInterfaces) {
        var _this = this;
        return searchInterfaces.map(function (searchInterface) { return coveo_search_ui_1.$$(searchInterface); })
            .map(function (searchInterface) { return _this.waitForSearchInterfaceInitialization(searchInterface); });
    };
    SearchboxInitializer.prototype.waitForSearchInterfaceInitialization = function (searchInterface) {
        return new Promise(function (resolve, reject) {
            searchInterface.on(coveo_search_ui_1.InitializationEvents.afterComponentsInitialization, function () { return resolve(); });
        });
    };
    return SearchboxInitializer;
}());
exports.SearchboxInitializer = SearchboxInitializer;


/***/ }),
/* 33 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var CoveoFieldsHandler = (function () {
    function CoveoFieldsHandler(externalFields, prefix, suffix) {
        this.externalFields = externalFields;
        this.prefix = prefix;
        this.suffix = suffix;
        this.loadExternalFields(externalFields);
        this.prefix = prefix;
        this.suffix = suffix;
    }
    CoveoFieldsHandler.prototype.toCoveo = function (fieldName) {
        if (this.isValidFieldName(fieldName)) {
            var fieldWithoutDelimiter = this.stripCoveoFieldDelimiter(fieldName);
            var translatedFieldWithoutDelimiter = this.translateFieldName(fieldWithoutDelimiter);
            return this.startsWithAt(fieldName) ? this.addCoveoFieldDelimiter(translatedFieldWithoutDelimiter) : translatedFieldWithoutDelimiter;
        }
        else {
            console.error("Could not translate the '" + fieldName + "' field to a Coveo field. Returning as is.");
            return fieldName;
        }
    };
    CoveoFieldsHandler.prototype.addCoveoFieldDelimiter = function (fieldName) {
        var fieldNameWithDelimiter = fieldName;
        if (!this.startsWithAt(fieldName)) {
            fieldNameWithDelimiter = ("" + CoveoFieldsHandler.coveoFieldDelimiter + fieldName).toLowerCase();
        }
        return fieldNameWithDelimiter;
    };
    CoveoFieldsHandler.prototype.loadExternalFields = function (externalFields) {
        var _this = this;
        this.externalFields = [];
        externalFields.forEach(function (externalField) {
            if (typeof (externalField) === "string") {
                _this.externalFields.push({
                    "fieldName": externalField,
                    "shouldEscape": false
                });
            }
            else if (_this.isExternalFieldConfig(externalField)) {
                _this.externalFields.push(externalField);
            }
            else {
                console.error("Invalid external field '" + externalField + "'.");
            }
        });
    };
    CoveoFieldsHandler.prototype.isValidFieldName = function (fieldName) {
        return typeof (fieldName) !== "undefined" && fieldName !== "";
    };
    CoveoFieldsHandler.prototype.startsWithAt = function (fieldName) {
        return fieldName[0] === CoveoFieldsHandler.coveoFieldDelimiter;
    };
    CoveoFieldsHandler.prototype.stripCoveoFieldDelimiter = function (fieldName) {
        var field = fieldName;
        if (this.startsWithAt(fieldName)) {
            field = field.substr(1);
        }
        return field;
    };
    CoveoFieldsHandler.prototype.translateFieldName = function (fieldName) {
        var field = fieldName;
        if (this.shouldReplaceSpecialCharacters(fieldName)) {
            field = this.replaceSpecialCharacters(field);
        }
        if (this.shouldDecorate(fieldName)) {
            field = this.prefix + field + this.suffix;
        }
        return field;
    };
    CoveoFieldsHandler.prototype.replaceSpecialCharacters = function (fieldName) {
        return fieldName.split("")
            .map(this.replaceSpecialCharacter.bind(this))
            .join("");
    };
    CoveoFieldsHandler.prototype.replaceSpecialCharacter = function (character) {
        if (character.match(CoveoFieldsHandler.nonSpecialCharacters)) {
            return character;
        }
        else {
            return this.escapeSpecialCharacter(character);
        }
    };
    CoveoFieldsHandler.prototype.escapeSpecialCharacter = function (character) {
        return "z" + character.charCodeAt(0) + "x";
    };
    CoveoFieldsHandler.prototype.shouldReplaceSpecialCharacters = function (fieldName) {
        var fields = this.externalFields.filter(function (field) { return field.fieldName === fieldName; });
        return fields.length > 0 ? fields[0].shouldEscape : true;
    };
    CoveoFieldsHandler.prototype.shouldDecorate = function (fieldName) {
        return !this.externalFields.some(function (field) { return field.fieldName === fieldName; });
    };
    CoveoFieldsHandler.prototype.isExternalFieldConfig = function (obj) {
        return typeof (obj) !== "undefined" &&
            typeof (obj.fieldName) !== "undefined" &&
            typeof (obj.shouldEscape) !== "undefined";
    };
    return CoveoFieldsHandler;
}());
// 'z' and 'x' are also considered as special characters because
// they are used in the escaping logic. So we have to remove them
// from the regular expression pattern.
CoveoFieldsHandler.nonSpecialCharacters = /[a-wyA-WY0-9]/;
CoveoFieldsHandler.coveoFieldDelimiter = "@";
exports.CoveoFieldsHandler = CoveoFieldsHandler;


/***/ }),
/* 34 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var CoveoLabelsHandler = (function () {
    function CoveoLabelsHandler(labels) {
        this.labels = labels;
    }
    CoveoLabelsHandler.prototype.translate = function (key) {
        return this.labels[key] || key;
    };
    return CoveoLabelsHandler;
}());
exports.CoveoLabelsHandler = CoveoLabelsHandler;


/***/ }),
/* 35 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var AnalyticsEnabled_1 = __webpack_require__(37);
var CoveoForSitecoreAnalyticsEndpoint_1 = __webpack_require__(38);
var CurrentPageName_1 = __webpack_require__(39);
var FieldTranslator_1 = __webpack_require__(40);
var IsAnonymous_1 = __webpack_require__(41);
var MainSearchInterfaceSelector_1 = __webpack_require__(42);
var SortCriteria_1 = __webpack_require__(43);
var UnfoldDictionaryToAttributes_1 = __webpack_require__(44);
var PrebindHelpers = (function () {
    function PrebindHelpers() {
    }
    PrebindHelpers.getAllPrebindHelpers = function () {
        return [
            new AnalyticsEnabled_1.AnalyticsEnabledPrebind(),
            new CoveoForSitecoreAnalyticsEndpoint_1.CoveoForSitecoreAnalyticsEndpointPrebind(),
            new CurrentPageName_1.CurrentPageNamePrebind(),
            new FieldTranslator_1.FieldTranslatorPrebind(),
            new IsAnonymous_1.IsAnonymousPrebind(),
            new MainSearchInterfaceSelector_1.MainSearchInterfaceSelectorPrebind(),
            new SortCriteria_1.SortCriteriaPrebind(),
            new UnfoldDictionaryToAttributes_1.UnfoldDictionaryToAttributesPrebind(),
        ];
    };
    return PrebindHelpers;
}());
exports.PrebindHelpers = PrebindHelpers;


/***/ }),
/* 36 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var PrebindResolver = (function () {
    function PrebindResolver() {
        this.prebindAppliedValue = "appliedPrebind";
        this.helpers = {};
    }
    PrebindResolver.prototype.registerPrebindHelper = function (helperName, handler) {
        if (typeof (helperName) !== "string" || helperName === "") {
            throw "You must define a name for the prebind helper.";
        }
        if (typeof (handler) === "undefined" || handler === null) {
            throw "You must define a handler for the prebind helper.";
        }
        if (this.helpers.hasOwnProperty(helperName)) {
            console.warn("A prebind handler already exists for '" + helperName + "'. It will be ignored");
            return;
        }
        this.helpers[helperName] = handler;
    };
    PrebindResolver.prototype.hasHelper = function (helperName) {
        return this.helpers.hasOwnProperty(helperName);
    };
    PrebindResolver.prototype.getHelper = function (helperName) {
        if (!this.hasHelper(helperName)) {
            throw "'" + helperName + "' has no registered helper.";
        }
        return this.helpers[helperName];
    };
    PrebindResolver.prototype.hasNotAppliedPrebind = function (element) {
        return element.dataset[this.prebindAppliedValue] !== "true";
    };
    PrebindResolver.prototype.applyToElement = function (element) {
        var _this = this;
        try {
            var attributes = this.getPrebindingAttributesForElement(element);
            if (attributes.length > 0) {
                element.dataset[this.prebindAppliedValue] = "true";
            }
            attributes.forEach(function (attributes) { return _this.applyPrebindToElement(attributes, element); });
        }
        catch (exception) {
            console.warn("(CoveoForSitecore) prebinding failed on element.", element, exception);
        }
    };
    PrebindResolver.prototype.getPrebindingAttributesForElement = function (element) {
        var _this = this;
        return this.getAllPrebindingAttributesNames(element).map(function (key) {
            var methodName = element.dataset[key];
            var attribute = _this.lowerCaseFirstCharacter(_this.removePrebindPrefix(key));
            return {
                attribute: attribute,
                attributeValue: element.dataset[attribute] || "",
                method: _this.getHelper(methodName)
            };
        });
    };
    PrebindResolver.prototype.getAllPrebindingAttributesNames = function (element) {
        var _this = this;
        return Object.keys(element.dataset)
            .filter(function (key) { return _this.stringStartsWithPrebindingString(key); })
            .filter(function (key) {
            var helperName = element.dataset[key];
            return _this.filterAndWarnNonExistingHelperName(helperName, element);
        });
    };
    PrebindResolver.prototype.stringStartsWithPrebindingString = function (value) {
        return value.lastIndexOf(PrebindResolver.prebindString) === 0;
    };
    PrebindResolver.prototype.filterAndWarnNonExistingHelperName = function (helperName, element) {
        var hasHelperWithName = this.hasHelper(helperName);
        if (!hasHelperWithName) {
            console.warn("(CoveoForSitecore) an unregistered prebinding '" + helperName + "' was set on the element. Register this method using Prebinding.registerPrebindHelper(\"" + helperName + "\", handler).", element);
        }
        return hasHelperWithName;
    };
    PrebindResolver.prototype.removePrebindPrefix = function (attributeName) {
        return attributeName.substring(PrebindResolver.prebindString.length);
    };
    PrebindResolver.prototype.lowerCaseFirstCharacter = function (value) {
        return value.charAt(0).toLowerCase() + value.slice(1);
    };
    PrebindResolver.prototype.applyPrebindToElement = function (prebind, element) {
        element.dataset[prebind.attribute] = prebind.method(prebind.attributeValue, element);
    };
    return PrebindResolver;
}());
PrebindResolver.prebindString = "prebind";
exports.PrebindResolver = PrebindResolver;


/***/ }),
/* 37 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var AnalyticsEnabledPrebind = (function () {
    function AnalyticsEnabledPrebind() {
        this.name = "analyticsEnabled";
    }
    AnalyticsEnabledPrebind.prototype.getPrebind = function (args) {
        return function (currentValue, element) {
            return args.context.scAnalyticsEnabled ? "true" : "false";
        };
    };
    return AnalyticsEnabledPrebind;
}());
exports.AnalyticsEnabledPrebind = AnalyticsEnabledPrebind;


/***/ }),
/* 38 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var CoveoForSitecoreAnalyticsEndpointPrebind = (function () {
    function CoveoForSitecoreAnalyticsEndpointPrebind() {
        this.name = "coveoForSitecoreAnalyticsEndpoint";
    }
    CoveoForSitecoreAnalyticsEndpointPrebind.prototype.getPrebind = function (args) {
        return function (currentValue, element) {
            return currentValue || args.context.scRestEndpointUri + "/coveoanalytics";
        };
    };
    return CoveoForSitecoreAnalyticsEndpointPrebind;
}());
exports.CoveoForSitecoreAnalyticsEndpointPrebind = CoveoForSitecoreAnalyticsEndpointPrebind;


/***/ }),
/* 39 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var CurrentPageNamePrebind = (function () {
    function CurrentPageNamePrebind() {
        this.name = "currentPageName";
    }
    CurrentPageNamePrebind.prototype.getPrebind = function (args) {
        return function (pageName, element) {
            return pageName || args.context.scPageName;
        };
    };
    return CurrentPageNamePrebind;
}());
exports.CurrentPageNamePrebind = CurrentPageNamePrebind;


/***/ }),
/* 40 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var FieldTranslatorPrebind = (function () {
    function FieldTranslatorPrebind() {
        this.name = "fieldTranslator";
    }
    FieldTranslatorPrebind.prototype.getPrebind = function (args) {
        return function (name, element) {
            return args.fieldsHandler.toCoveo(name);
        };
    };
    return FieldTranslatorPrebind;
}());
exports.FieldTranslatorPrebind = FieldTranslatorPrebind;


/***/ }),
/* 41 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var IsAnonymousPrebind = (function () {
    function IsAnonymousPrebind() {
        this.name = "isAnonymous";
    }
    IsAnonymousPrebind.prototype.getPrebind = function (args) {
        return function (isAnonymous, element) {
            return args.context.scIsUserAnonymous ? "true" : "false";
        };
    };
    return IsAnonymousPrebind;
}());
exports.IsAnonymousPrebind = IsAnonymousPrebind;


/***/ }),
/* 42 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var coveo_search_ui_1 = __webpack_require__(0);
var MainSearchInterfaceSelectorPrebind = (function () {
    function MainSearchInterfaceSelectorPrebind() {
        this.name = "mainSearchInterfaceSelector";
        this.resolvers = [
            new ResolveIfSelector(),
            new ResolveIfSearchInterfaceIdInPage(),
            new ResolveParentSearchInterfaceId(),
            new UseMainSearchInterfaceSelectorAsIs()
        ];
    }
    MainSearchInterfaceSelectorPrebind.prototype.getPrebind = function (args) {
        var _this = this;
        return function (mainSearchInterfaceId, element) {
            var resolver = _this.getFirstValidResolver(mainSearchInterfaceId, element);
            return resolver.getValue(mainSearchInterfaceId, element);
        };
    };
    MainSearchInterfaceSelectorPrebind.prototype.getFirstValidResolver = function (mainSearchInterfaceId, element) {
        var resolver;
        do {
            if (this.resolvers.length === 0) {
                var message = "Could not resolve the search interface element using the current resolver. Ensure that a valid value is set.";
                console.error(message, {
                    mainSearchInterfaceId: mainSearchInterfaceId,
                    element: element
                });
                throw message;
            }
            resolver = this.resolvers.shift();
        } while (!resolver.canResolve(mainSearchInterfaceId, element));
        return resolver;
    };
    return MainSearchInterfaceSelectorPrebind;
}());
exports.MainSearchInterfaceSelectorPrebind = MainSearchInterfaceSelectorPrebind;
var ResolveIfSearchInterfaceIdInPage = (function () {
    function ResolveIfSearchInterfaceIdInPage() {
    }
    ResolveIfSearchInterfaceIdInPage.prototype.canResolve = function (mainSearchInterfaceId) {
        return this.isMainSearchInterfaceDefined(mainSearchInterfaceId) &&
            this.isIdSelectorValid("#" + mainSearchInterfaceId);
    };
    ResolveIfSearchInterfaceIdInPage.prototype.getValue = function (mainSearchInterfaceId) {
        return "#" + mainSearchInterfaceId;
    };
    ResolveIfSearchInterfaceIdInPage.prototype.isMainSearchInterfaceDefined = function (mainSearchInterfaceId) {
        return !!mainSearchInterfaceId;
    };
    ResolveIfSearchInterfaceIdInPage.prototype.isIdSelectorValid = function (selector) {
        return document.querySelector(selector) !== null;
    };
    return ResolveIfSearchInterfaceIdInPage;
}());
var ResolveParentSearchInterfaceId = (function () {
    function ResolveParentSearchInterfaceId() {
    }
    ResolveParentSearchInterfaceId.prototype.canResolve = function (mainSearchInterfaceId, element) {
        return this.getValue(mainSearchInterfaceId, element) !== null;
    };
    ResolveParentSearchInterfaceId.prototype.getValue = function (mainSearchInterfaceId, element) {
        if (typeof (this.foundId) === "undefined") {
            this.foundId = this.tryFindParentSearchInterfaceFromElement(element);
        }
        return this.foundId;
    };
    ResolveParentSearchInterfaceId.prototype.tryFindParentSearchInterfaceFromElement = function (element) {
        var parentSearchInterface = this.findParentWithClass(element, "Coveo" + coveo_search_ui_1.SearchInterface.ID);
        return !!parentSearchInterface ? "#" + parentSearchInterface.id : null;
    };
    ResolveParentSearchInterfaceId.prototype.findParentWithClass = function (element, className) {
        var parent = element.parentElement;
        while ((parent = parent.parentElement) && !parent.classList.contains(className)) { }
        return parent;
    };
    return ResolveParentSearchInterfaceId;
}());
var ResolveIfSelector = (function () {
    function ResolveIfSelector() {
    }
    ResolveIfSelector.prototype.canResolve = function (mainSearchInterfaceId, element) {
        return !!mainSearchInterfaceId &&
            this.isStartingWithSelectorCharacter(mainSearchInterfaceId);
    };
    ResolveIfSelector.prototype.getValue = function (mainSearchInterfaceId, element) {
        return mainSearchInterfaceId;
    };
    ResolveIfSelector.prototype.isStartingWithSelectorCharacter = function (mainSearchInterfaceId) {
        var firstCharacter = mainSearchInterfaceId[0];
        return [".", "#"].indexOf(firstCharacter) !== -1;
    };
    return ResolveIfSelector;
}());
var UseMainSearchInterfaceSelectorAsIs = (function () {
    function UseMainSearchInterfaceSelectorAsIs() {
    }
    UseMainSearchInterfaceSelectorAsIs.prototype.canResolve = function (mainSearchInterfaceId, element) {
        return true;
    };
    UseMainSearchInterfaceSelectorAsIs.prototype.getValue = function (mainSearchInterfaceId, element) {
        return mainSearchInterfaceId;
    };
    return UseMainSearchInterfaceSelectorAsIs;
}());


/***/ }),
/* 43 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var SortCriteriaResolver_1 = __webpack_require__(45);
var SortCriteriaPrebind = (function () {
    function SortCriteriaPrebind() {
        this.name = "sortCriteriaResolver";
    }
    SortCriteriaPrebind.prototype.getPrebind = function (args) {
        var criteriaResolver = new SortCriteriaResolver_1.SortCriteriaResolver(args.fieldsHandler);
        return function (sortCriteriaRawValue, element) {
            var sortCriteria = JSON.parse(sortCriteriaRawValue);
            if (Object.keys(sortCriteria).length === 0) {
                return null;
            }
            var sortType = (sortCriteria.type || "relevancy").toLowerCase();
            var sortDirection = (sortCriteria.direction || "ascending").toLowerCase();
            var toggleDirection = (element.dataset["scEnableDirectionToggle"] || "false").toLowerCase() === "true";
            if (sortType === "relevancy") {
                return criteriaResolver.resolveRelevancyCriteria();
            }
            else if (sortType === "date") {
                return criteriaResolver.resolveDateCriteria(sortDirection, toggleDirection);
            }
            else {
                var sortField = sortCriteria.field;
                return criteriaResolver.resolveFieldCriteria(sortField, sortDirection, toggleDirection);
            }
        };
    };
    return SortCriteriaPrebind;
}());
exports.SortCriteriaPrebind = SortCriteriaPrebind;


/***/ }),
/* 44 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var UnfoldDictionaryToAttributesPrebind = (function () {
    function UnfoldDictionaryToAttributesPrebind() {
        this.name = "unfoldDictionaryToAttributesPrebind";
    }
    UnfoldDictionaryToAttributesPrebind.prototype.getPrebind = function (args) {
        return function (rawDictionary, element) {
            var parsedDictionary = JSON.parse(rawDictionary);
            Object.keys(parsedDictionary).forEach(function (key) {
                var translatedField = args.fieldsHandler.toCoveo(key);
                var dataKey = "field" + translatedField.charAt(0).toUpperCase() + translatedField.slice(1);
                element.dataset[dataKey] = parsedDictionary[key];
            });
            return rawDictionary;
        };
    };
    return UnfoldDictionaryToAttributesPrebind;
}());
exports.UnfoldDictionaryToAttributesPrebind = UnfoldDictionaryToAttributesPrebind;


/***/ }),
/* 45 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var SortCriteriaResolver = (function () {
    function SortCriteriaResolver(fieldsHandler) {
        this.fieldsHandler = fieldsHandler;
    }
    SortCriteriaResolver.prototype.resolveFieldCriteria = function (fieldCriteria, sortDirection, enableToggle) {
        var field = fieldCriteria.charAt(0) !== "@" ? "@" + fieldCriteria : fieldCriteria;
        return this.getFieldCriteria(this.fieldsHandler.toCoveo(field), sortDirection, enableToggle);
    };
    SortCriteriaResolver.prototype.resolveDateCriteria = function (sortDirection, enableToggle) {
        return this.getFieldCriteria("date", sortDirection, enableToggle);
    };
    SortCriteriaResolver.prototype.resolveRelevancyCriteria = function () {
        return "relevancy";
    };
    SortCriteriaResolver.prototype.getFieldCriteria = function (fieldCriteria, sortDirection, enableToggle) {
        if (enableToggle) {
            return this.getFieldWithDirection(fieldCriteria, sortDirection) + ", " + this.getFieldWithDirection(fieldCriteria, this.getInvertedDirection(sortDirection));
        }
        else {
            return this.getFieldWithDirection(fieldCriteria, sortDirection);
        }
    };
    SortCriteriaResolver.prototype.getFieldWithDirection = function (fieldCriteria, sortDirection) {
        return fieldCriteria + " " + sortDirection;
    };
    SortCriteriaResolver.prototype.getInvertedDirection = function (sortDirection) {
        return sortDirection === "descending" ? "ascending" : "descending";
    };
    return SortCriteriaResolver;
}());
exports.SortCriteriaResolver = SortCriteriaResolver;


/***/ }),
/* 46 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var coveo_search_ui_1 = __webpack_require__(0);
var HTMLUtils_1 = __webpack_require__(7);
var SearchInterfacesProvider = (function () {
    function SearchInterfacesProvider() {
    }
    SearchInterfacesProvider.prototype.getSearchInterfacesInPage = function (componentsIds) {
        var searchInterfacesSelector = this.getSearchInterfacesSelectorFromComponentIds(componentsIds);
        var searchInterfaces = document.querySelectorAll(searchInterfacesSelector);
        return HTMLUtils_1.nodeListToArray(searchInterfaces);
    };
    SearchInterfacesProvider.prototype.getSearchInterfacesSelectorFromComponentIds = function (componentIds) {
        return componentIds.map(function (componentId) { return coveo_search_ui_1.Component.computeSelectorForType(componentId); })
            .join(", ");
    };
    return SearchInterfacesProvider;
}());
exports.SearchInterfacesProvider = SearchInterfacesProvider;


/***/ }),
/* 47 */,
/* 48 */,
/* 49 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var coveo_search_ui_1 = __webpack_require__(0);
function lazyCoveoForSitecoreAnalytics() {
    coveo_search_ui_1.LazyInitialization.registerLazyComponent("ForSitecoreAnalytics", function () {
        return new Promise(function (resolve, reject) {
            __webpack_require__.e/* require.ensure */(12).then((function () {
                var loaded = __webpack_require__(14)["CoveoForSitecoreAnalytics"];
                resolve(loaded);
            }).bind(null, __webpack_require__)).catch(coveo_search_ui_1.LazyInitialization.buildErrorCallback("CoveoForSitecoreAnalytics", resolve));
        });
    });
}
exports.lazyCoveoForSitecoreAnalytics = lazyCoveoForSitecoreAnalytics;


/***/ }),
/* 50 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var coveo_search_ui_1 = __webpack_require__(0);
function lazyCoveoSendAnalyticsToSitecore() {
    coveo_search_ui_1.LazyInitialization.registerLazyComponent("SendAnalyticsToSitecore", function () {
        return new Promise(function (resolve, reject) {
            __webpack_require__.e/* require.ensure */(5).then((function () {
                var loaded = __webpack_require__(15)["SendAnalyticsToSitecore"];
                resolve(loaded);
            }).bind(null, __webpack_require__)).catch(coveo_search_ui_1.LazyInitialization.buildErrorCallback("SendAnalyticsToSitecore", resolve));
        });
    });
}
exports.lazyCoveoSendAnalyticsToSitecore = lazyCoveoSendAnalyticsToSitecore;


/***/ }),
/* 51 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var coveo_search_ui_1 = __webpack_require__(0);
function lazyValidateAnalyticsIncluded() {
    coveo_search_ui_1.LazyInitialization.registerLazyComponent("ValidateAnalyticsIncluded", function () {
        return new Promise(function (resolve, reject) {
            __webpack_require__.e/* require.ensure */(11).then((function () {
                var loaded = __webpack_require__(16)["ValidateAnalyticsIncluded"];
                resolve(loaded);
            }).bind(null, __webpack_require__)).catch(coveo_search_ui_1.LazyInitialization.buildErrorCallback("ValidateAnalyticsIncluded", resolve));
        });
    });
}
exports.lazyValidateAnalyticsIncluded = lazyValidateAnalyticsIncluded;


/***/ }),
/* 52 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var coveo_search_ui_1 = __webpack_require__(0);
function lazyCoveoForSitecoreBindWithUserContext() {
    coveo_search_ui_1.LazyInitialization.registerLazyComponent("ForSitecoreBindWithUserContext", function () {
        return new Promise(function (resolve, reject) {
            __webpack_require__.e/* require.ensure */(10).then((function () {
                var loaded = __webpack_require__(17)["CoveoForSitecoreBindWithUserContext"];
                resolve(loaded);
            }).bind(null, __webpack_require__)).catch(coveo_search_ui_1.LazyInitialization.buildErrorCallback("CoveoForSitecoreBindWithUserContext", resolve));
        });
    });
}
exports.lazyCoveoForSitecoreBindWithUserContext = lazyCoveoForSitecoreBindWithUserContext;


/***/ }),
/* 53 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var coveo_search_ui_1 = __webpack_require__(0);
function lazyCoveoDistanceResources() {
    coveo_search_ui_1.LazyInitialization.registerLazyComponent("DistanceResources", function () {
        return new Promise(function (resolve, reject) {
            __webpack_require__.e/* require.ensure */(2).then((function () {
                var loaded = __webpack_require__(18)["DistanceResources"];
                resolve(loaded);
            }).bind(null, __webpack_require__)).catch(coveo_search_ui_1.LazyInitialization.buildErrorCallback("DistanceResources", resolve));
        });
    });
}
exports.lazyCoveoDistanceResources = lazyCoveoDistanceResources;


/***/ }),
/* 54 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var coveo_search_ui_1 = __webpack_require__(0);
function lazyCoveoGoogleApiPositionProvider() {
    coveo_search_ui_1.LazyInitialization.registerLazyComponent("GoogleApiPositionProvider", function () {
        return new Promise(function (resolve, reject) {
            __webpack_require__.e/* require.ensure */(3).then((function () {
                var loaded = __webpack_require__(19)["GoogleApiPositionProvider"];
                resolve(loaded);
            }).bind(null, __webpack_require__)).catch(coveo_search_ui_1.LazyInitialization.buildErrorCallback("GoogleApiPositionProvider", resolve));
        });
    });
}
exports.lazyCoveoGoogleApiPositionProvider = lazyCoveoGoogleApiPositionProvider;


/***/ }),
/* 55 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var coveo_search_ui_1 = __webpack_require__(0);
function lazyCoveoNavigatorPositionProvider() {
    coveo_search_ui_1.LazyInitialization.registerLazyComponent("NavigatorPositionProvider", function () {
        return new Promise(function (resolve, reject) {
            __webpack_require__.e/* require.ensure */(7).then((function () {
                var loaded = __webpack_require__(20)["NavigatorPositionProvider"];
                resolve(loaded);
            }).bind(null, __webpack_require__)).catch(coveo_search_ui_1.LazyInitialization.buildErrorCallback("NavigatorPositionProvider", resolve));
        });
    });
}
exports.lazyCoveoNavigatorPositionProvider = lazyCoveoNavigatorPositionProvider;


/***/ }),
/* 56 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var coveo_search_ui_1 = __webpack_require__(0);
function lazyCoveoStaticPositionProvider() {
    coveo_search_ui_1.LazyInitialization.registerLazyComponent("StaticPositionProvider", function () {
        return new Promise(function (resolve, reject) {
            __webpack_require__.e/* require.ensure */(6).then((function () {
                var loaded = __webpack_require__(21)["StaticPositionProvider"];
                resolve(loaded);
            }).bind(null, __webpack_require__)).catch(coveo_search_ui_1.LazyInitialization.buildErrorCallback("StaticPositionProvider", resolve));
        });
    });
}
exports.lazyCoveoStaticPositionProvider = lazyCoveoStaticPositionProvider;


/***/ }),
/* 57 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var coveo_search_ui_1 = __webpack_require__(0);
function lazyCoveoForSitecoreExpressions() {
    coveo_search_ui_1.LazyInitialization.registerLazyComponent("ForSitecoreExpressions", function () {
        return new Promise(function (resolve, reject) {
            __webpack_require__.e/* require.ensure */(9).then((function () {
                var loaded = __webpack_require__(22)["CoveoForSitecoreExpressions"];
                resolve(loaded);
            }).bind(null, __webpack_require__)).catch(coveo_search_ui_1.LazyInitialization.buildErrorCallback("CoveoForSitecoreExpressions", resolve));
        });
    });
}
exports.lazyCoveoForSitecoreExpressions = lazyCoveoForSitecoreExpressions;


/***/ }),
/* 58 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var coveo_search_ui_1 = __webpack_require__(0);
function lazyCoveoForSitecoreExternalContent() {
    coveo_search_ui_1.LazyInitialization.registerLazyComponent("ForSitecoreExternalContent", function () {
        return new Promise(function (resolve, reject) {
            __webpack_require__.e/* require.ensure */(4).then((function () {
                var loaded = __webpack_require__(23)["CoveoForSitecoreExternalContent"];
                resolve(loaded);
            }).bind(null, __webpack_require__)).catch(coveo_search_ui_1.LazyInitialization.buildErrorCallback("CoveoForSitecoreExternalContent", resolve));
        });
    });
}
exports.lazyCoveoForSitecoreExternalContent = lazyCoveoForSitecoreExternalContent;


/***/ }),
/* 59 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var coveo_search_ui_1 = __webpack_require__(0);
function lazyCoveoForSitecoreFilterExpression() {
    coveo_search_ui_1.LazyInitialization.registerLazyComponent("ForSitecoreFilterExpression", function () {
        return new Promise(function (resolve, reject) {
            __webpack_require__.e/* require.ensure */(1).then((function () {
                var loaded = __webpack_require__(24)["CoveoForSitecoreFilterExpression"];
                resolve(loaded);
            }).bind(null, __webpack_require__)).catch(coveo_search_ui_1.LazyInitialization.buildErrorCallback("CoveoForSitecoreFilterExpression", resolve));
        });
    });
}
exports.lazyCoveoForSitecoreFilterExpression = lazyCoveoForSitecoreFilterExpression;


/***/ }),
/* 60 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var coveo_search_ui_1 = __webpack_require__(0);
function lazyCoveoForSitecoreLocalExpression() {
    coveo_search_ui_1.LazyInitialization.registerLazyComponent("ForSitecoreLocalExpression", function () {
        return new Promise(function (resolve, reject) {
            __webpack_require__.e/* require.ensure */(8).then((function () {
                var loaded = __webpack_require__(25)["CoveoForSitecoreLocalExpression"];
                resolve(loaded);
            }).bind(null, __webpack_require__)).catch(coveo_search_ui_1.LazyInitialization.buildErrorCallback("CoveoForSitecoreLocalExpression", resolve));
        });
    });
}
exports.lazyCoveoForSitecoreLocalExpression = lazyCoveoForSitecoreLocalExpression;


/***/ }),
/* 61 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var coveo_search_ui_1 = __webpack_require__(0);
function lazyCoveoForSitecoreRankingExpression() {
    coveo_search_ui_1.LazyInitialization.registerLazyComponent("ForSitecoreRankingExpression", function () {
        return new Promise(function (resolve, reject) {
            __webpack_require__.e/* require.ensure */(0).then((function () {
                var loaded = __webpack_require__(26)["CoveoForSitecoreRankingExpression"];
                resolve(loaded);
            }).bind(null, __webpack_require__)).catch(coveo_search_ui_1.LazyInitialization.buildErrorCallback("CoveoForSitecoreRankingExpression", resolve));
        });
    });
}
exports.lazyCoveoForSitecoreRankingExpression = lazyCoveoForSitecoreRankingExpression;


/***/ }),
/* 62 */,
/* 63 */,
/* 64 */,
/* 65 */,
/* 66 */,
/* 67 */,
/* 68 */,
/* 69 */,
/* 70 */,
/* 71 */,
/* 72 */,
/* 73 */
/***/ (function(module, exports) {

module.exports = CoveoForSitecoreUserContext;

/***/ }),
/* 74 */,
/* 75 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
Object.defineProperty(exports, "__esModule", { value: true });
var coveo_search_ui_1 = __webpack_require__(0);
__webpack_require__.p = coveo_search_ui_1.PublicPathUtils.getDynamicPublicPath();
var CoveoForSitecoreContext_1 = __webpack_require__(5);
exports.CoveoForSitecoreContext = CoveoForSitecoreContext_1.CoveoForSitecoreContext;
var LazyCoveoForSitecoreAnalytics_1 = __webpack_require__(49);
LazyCoveoForSitecoreAnalytics_1.lazyCoveoForSitecoreAnalytics();
var LazySendAnalyticsToSitecore_1 = __webpack_require__(50);
LazySendAnalyticsToSitecore_1.lazyCoveoSendAnalyticsToSitecore();
var LazyValidateAnalyticsIncluded_1 = __webpack_require__(51);
LazyValidateAnalyticsIncluded_1.lazyValidateAnalyticsIncluded();
var LazyCoveoForSitecoreBindWithUserContext_1 = __webpack_require__(52);
LazyCoveoForSitecoreBindWithUserContext_1.lazyCoveoForSitecoreBindWithUserContext();
var LazyCoveoForSitecoreExpressions_1 = __webpack_require__(57);
LazyCoveoForSitecoreExpressions_1.lazyCoveoForSitecoreExpressions();
var LazyCoveoForSitecoreRankingExpression_1 = __webpack_require__(61);
LazyCoveoForSitecoreRankingExpression_1.lazyCoveoForSitecoreRankingExpression();
var LazyCoveoForSitecoreExternalContent_1 = __webpack_require__(58);
LazyCoveoForSitecoreExternalContent_1.lazyCoveoForSitecoreExternalContent();
var LazyCoveoForSitecoreFilterExpression_1 = __webpack_require__(59);
LazyCoveoForSitecoreFilterExpression_1.lazyCoveoForSitecoreFilterExpression();
var LazyCoveoForSitecoreLocalExpression_1 = __webpack_require__(60);
LazyCoveoForSitecoreLocalExpression_1.lazyCoveoForSitecoreLocalExpression();
var LazyDistanceResources_1 = __webpack_require__(53);
LazyDistanceResources_1.lazyCoveoDistanceResources();
var LazyGoogleApiPositionProvider_1 = __webpack_require__(54);
LazyGoogleApiPositionProvider_1.lazyCoveoGoogleApiPositionProvider();
var LazyNavigatorPositionProvider_1 = __webpack_require__(55);
LazyNavigatorPositionProvider_1.lazyCoveoNavigatorPositionProvider();
var LazyStaticPositionProvider_1 = __webpack_require__(56);
LazyStaticPositionProvider_1.lazyCoveoStaticPositionProvider();
__export(__webpack_require__(12));
__export(__webpack_require__(11));
__export(__webpack_require__(4));


/***/ })
/******/ ]);
});


// WEBPACK FOOTER //
// CoveoForSitecore.Lazy.min.js